import type {
  CreateMessageParams,
  CreateMessageResponse,
  ListConversationsResponse,
  ListMessagesParams,
  ListMessagesResponse,
  ListUnreadConversationsResponse,
} from '$shared/api';
import { BaseService } from './utils/BaseService';

export class ChatService extends BaseService {
  createMessage(data: CreateMessageParams): Promise<CreateMessageResponse> {
    return this.client.send('/api/chat/message', {
      method: 'POST',
      body: data,
    });
  }

  getUserConversations(): Promise<ListConversationsResponse[]> {
    return this.client.send('/api/chat/conversations', {
      method: 'GET',
    });
  }

  getUnreadConversations(): Promise<ListUnreadConversationsResponse> {
    return this.client.send('/api/chat/unread_conversations', {
      method: 'GET',
    });
  }

  markConversationAsRead(conversationId: number, data: { lastReadAt: number }) {
    return this.client.send(`/api/chat/conversations/${conversationId}`, {
      method: 'POST',
      body: data,
    });
  }

  getConversationMessages(
    conversationId: number,
    query?: ListMessagesParams,
  ): Promise<ListMessagesResponse> {
    return this.client.send(`/api/chat/conversations/${conversationId}`, {
      method: 'GET',
      query,
    });
  }
}
